<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: 'App'
    }
</script>

<style lang="less">
.interface-item{display: flex;padding: 10px 0;}
.left-title{font-size: 16px;min-width: 74px;font-weight: bold;padding: 5px 0;margin-right: 10px;}
.right-list{font-size: 16px;height: 35px;overflow: hidden;transition: all .3s;
    button:first-child{margin-left: 0px!important;}
    button{font-size: 16px;}
    button:last-child{margin-right: 0!important;}
}
.crumbs{align-items: center;color: #515A6E;
    a{font-size: 14px;color: #515A6E;
        i{font-size: 14px;margin-right: 10px;}
        &:hover{color: #8186FA!important;}
    }
    .link-active{color: #8186FA!important;
        i{font-size: 14px;margin-right: 10px;}
    }
    .arrow{margin: 0 10px;font-family: '宋体';font-weight: bold;font-size: 14px;}
}
body{
    .ivu-input:hover{border-color:#8186FA;}
    .ivu-input:focus{border-color:#8186FA;box-shadow: none;}
    .ivu-date-picker-focused input{border-color: #8186FA;box-shadow: none;}
    .ivu-date-picker-cells-focused em{box-shadow: 0 0 0 1px #8186FA inset;}
    .ivu-date-picker-cells-cell-today em:after{background: #8186FA;}
    .ivu-btn-primary{background-color: #8186FA;border-color: #8186FA;}
    .ivu-btn-text:hover{color: #8186FA;background-color: rgba(0, 0, 0, 0);}
    .ivu-btn-primary:focus{box-shadow: none;}
    .ivu-btn-text:focus{box-shadow: none;}
    .ivu-btn-primary:hover{background-color: #8186FA;border-color: #8186FA;}
    .ivu-tag-primary, .ivu-tag-primary.ivu-tag-dot .ivu-tag-dot-inner{background: #8186FA;}
    .ivu-breadcrumb{
        a{line-height: 21px;
            .ivu-icon-ios-home{position: relative;top: -1px;}
        }
    }
    .ivu-btn{padding: 3px 8px 3px;}
}
</style>



// WEBPACK FOOTER //
// src/App.vue